import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Restores report statuses from sessionStorage on page load
// This enables tab-specific persistence - only the tab where report was initiated shows the status
export default class extends Controller {
  connect() {
    this.restoreActiveReports()
  }

  async restoreActiveReports() {
    // Get active report cache IDs from sessionStorage
    const activeReports = JSON.parse(sessionStorage.getItem('activeReportCaches') || '[]')
    
    if (activeReports.length === 0) {
      return
    }

    try {
      // Fetch report statuses from server
      const response = await fetch('/report_caches/active', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ report_cache_ids: activeReports })
      })

      if (!response.ok) {
        logger.error('Failed to fetch active report caches:', response.statusText)
        return
      }

      const data = await response.json()
      
      // Render each active report status
      if (data.reports && data.reports.length > 0) {
        this.renderReportStatuses(data.reports)
      }
    } catch (error) {
      logger.error('Error restoring report statuses:', error)
    }
  }

  renderReportStatuses(reports) {
    // Find or create the report statuses container
    let reportStatusesContainer = document.getElementById('reportStatuses')
    
    if (!reportStatusesContainer) {
      reportStatusesContainer = document.createElement('div')
      reportStatusesContainer.id = 'reportStatuses'
      reportStatusesContainer.className = 'sidebar-aware'
      
      document.body.appendChild(reportStatusesContainer)
      
      // Manually apply sidebar-collapsed class based on current sidebar state
      // Check the body element for the sidebar controller's collapsed state
      const bodyElement = document.body
      const hasSidebarController = bodyElement.dataset.controller?.includes('sidebar')
      
      if (hasSidebarController) {
        const sidebarCollapsed = bodyElement.dataset.sidebarCollapsedValue === 'true'
        
        if (sidebarCollapsed) {
          reportStatusesContainer.classList.add('sidebar-collapsed')
        }
      }
      
      // Force a reflow to ensure CSS is applied before adding content
      reportStatusesContainer.offsetHeight
    }

    // Render each report status
    reports.forEach((report) => {
      // Check if this report status is already in the DOM
      if (document.getElementById(`reportStatus${report.id}`)) {
        return // Skip if already rendered
      }

      // Insert the HTML
      reportStatusesContainer.insertAdjacentHTML('beforeend', report.html)
    })
    
    // Function to update CSS custom property for overlay height
    function updateReportStatusOverlayHeight() {
      const container = document.getElementById('reportStatuses')
      if (container && container.classList.contains('show')) {
        requestAnimationFrame(() => {
          const height = container.offsetHeight
          document.documentElement.style.setProperty('--report-status-overlay-height', height + 'px')
        })
      } else {
        document.documentElement.style.setProperty('--report-status-overlay-height', '0px')
      }
    }
    
    // Expose function globally for report controller to use
    window.updateReportStatusOverlayHeight = updateReportStatusOverlayHeight

    // Listen for sidebar updates so we can recalc sizes after the
    // sidebar controller toggles `.sidebar-collapsed` on `.sidebar-aware` elements.
    document.addEventListener('sidebar:updated', () => {
      if (window.updateReportStatusOverlayHeight) {
        // Defer to next frame to allow CSS transitions to settle
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.updateReportStatusOverlayHeight()
          }, 20)
        })
      }
    })
    
    // Show the container after a brief delay
    setTimeout(() => {
      reportStatusesContainer.classList.add('show')
      setTimeout(() => {
        updateReportStatusOverlayHeight()
      }, 50)
    }, 1)
  }
}

